import React from "react";
import Link from "next/link";

import { Contact } from "./Contact";
import { LocationList } from "./LocationList";
import { useStore } from "../../context/state";
import { SubMenu } from "../../components/SubMenu";

import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";

export const Page = () => {
    const { dispatch, apiPath } = useStore();
  return (
    <div className="background-wrapper">
      <div className="container u-xs-padding0">
        <div className="paper-box u-paddingLeft80 u-paddingRight80 u-xs-paddingHorizontal24">
          <SubMenu />
          <span className="u-textColorPrimary u-fontSize28 u-fontWeightBold">
            CONTACT US
          </span>
          <div className="u-marginTop10 u-paddingBottom8 u-borderBottom1 u-borderColorLighter">
            <Breadcrumbs className=" u-textColorDarker" className=" u-textColorDarker" aria-label="breadcrumb">
              <Link href="/" color="inherit" className="u-cursorPointer">
                Home
              </Link>
              <Typography >Contact Us</Typography>
            </Breadcrumbs>
          </div>
          <div className="u-marginTop10 u-xs-marginTop30">
            <Contact apiPath={apiPath} dispatch={dispatch}/>
          </div>
          <div className="u-marginTop50 u-paddingBottom50">
            <LocationList />
          </div>
        </div>
      </div>
    </div>
  );
};
